import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {NearbyOffersPanel} from "../../../nearby_offers/NearbyOffersPanel";
import {NearbyOffersPanelPlaceholder} from "../../../nearby_offers/NearbyOffersPanelPlaceholder";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {neighborhoodOffersViewHit} from "../../../tracking/algolytics_hits/neighborhood_offers_view_hit";
import {ViewType} from "../../../view_type/ViewType";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {ISlugParsed} from "../../helpers/friendly_offer_list/offer_url_parser";
import {offerBoxTracking} from "../../tracking/offer_box_gtm_events";
import {getListingPageNearbyOffersPayload} from "../../utils/get_listing_page_nearby_offers_payload";

interface IProps {
    viewType: ViewType;
    regionWhere: string;
    offerParams: Partial<ISlugParsed> | null;
    isSidebarReserved?: boolean;
}

/**
 *  `NearbyOffersMoreCard` is already styled, but we are waiting for business to define logic that should display it.
 *  After this logic is defined, check if this component can be merged with `DetailNearbyOffers`
 */
export const OfferListNearbyOffers: React.FunctionComponent<IProps> = (props) => {
    const {viewType, offerParams} = props;
    const list = useSelector((state: IRPStore) => state.offerList.list);
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const singleRegion = selectedRegions.length === 1 ? selectedRegions[0] : undefined;
    const nearbyOffersPayload = getListingPageNearbyOffersPayload({offerParams, singleRegion});

    const {
        data: nearbyOffersResponse,
        isSuccess,
        isUninitialized,
        isLoading,
        isFetching,
        isError
    } = useGetOfferListQuery(nearbyOffersPayload, {
        skip: list.requestState !== RequestState.Success
    });

    const nearbyOffers = nearbyOffersResponse ? nearbyOffersResponse.results : [];

    // Neighborhood offers hits
    useEffect(() => {
        if (!isEmpty(nearbyOffers)) {
            neighborhoodOffersViewHit(
                viewType,
                nearbyOffers.map((off: {id: number}) => off.id)
            );
        }
    }, [JSON.stringify(nearbyOffers)]);

    const listingHeadline = `Oferty ${singleRegion?.name_declension_where}, które mogą Cię zainteresować`;
    const listId = "oferty_ktore_moga_cie_zainteresowac";

    return (
        <>
            <Text variant="headline_4" as="h2" className={headingStyle}>
                {listingHeadline}
            </Text>

            {!isSuccess ? (
                <NearbyOffersPanelPlaceholder />
            ) : (
                <NearbyOffersPanel
                    addressContext={
                        singleRegion
                            ? {
                                  searchedRegion: singleRegion,
                                  searchDistance: nearbyOffersPayload.distance
                              }
                            : undefined
                    }
                    offersNearby={nearbyOffers}
                    trackingMeta={{
                        listId,
                        listName: listingHeadline,
                        source: "additional",
                        tileEvents: {
                            imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                            buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                            linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                            logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                        }
                    }}
                    modalQuery={{
                        isInitialized: !isUninitialized,
                        isSuccess,
                        isLoading: isLoading || isFetching,
                        isError,
                        requestState: getRequestStateFromRtkQuery({isSuccess, isLoading, isFetching, isError}),
                        data: nearbyOffers,
                        count: nearbyOffers.length,
                        page: nearbyOffersResponse.page,
                        pageSize: nearbyOffersResponse.page_size
                    }}
                    isSidebarReserved={props.isSidebarReserved}
                />
            )}
        </>
    );
};

const headingStyle = css({
    marginBottom: 3,
    md: {
        marginBottom: 4
    }
});
import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {isEmpty} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";

import {IRPStore} from "../../../app/rp_reducer";
import {NearbyOffersPanel} from "../../../nearby_offers/NearbyOffersPanel";
import {NearbyOffersPanelPlaceholder} from "../../../nearby_offers/NearbyOffersPanelPlaceholder";
import {getRequestStateFromRtkQuery} from "../../../store/utils/get_request_state_from_rtk_query";
import {neighborhoodOffersViewHit} from "../../../tracking/algolytics_hits/neighborhood_offers_view_hit";
import {ViewType} from "../../../view_type/ViewType";
import {useGetOfferListQuery} from "../../api/get_offer_list";
import {ISlugParsed} from "../../helpers/friendly_offer_list/offer_url_parser";
import {offerBoxTracking} from "../../tracking/offer_box_gtm_events";
import {getListingPageNearbyOffersPayload} from "../../utils/get_listing_page_nearby_offers_payload";

interface IProps {
    viewType: ViewType;
    regionWhere: string;
    offerParams: Partial<ISlugParsed> | null;
    isSidebarReserved?: boolean;
}

/**
 *  `NearbyOffersMoreCard` is already styled, but we are waiting for business to define logic that should display it.
 *  After this logic is defined, check if this component can be merged with `DetailNearbyOffers`
 */
export const OfferListNearbyOffers: React.FunctionComponent<IProps> = (props) => {
    const {viewType, offerParams} = props;
    const list = useSelector((state: IRPStore) => state.offerList.list);
    const selectedRegions = useSelector((state: IRPStore) => state.offerList.selectedRegions);
    const singleRegion = selectedRegions.length === 1 ? selectedRegions[0] : undefined;
    const nearbyOffersPayload = getListingPageNearbyOffersPayload({offerParams, singleRegion});

    const {
        data: nearbyOffersResponse,
        isSuccess,
        isUninitialized,
        isLoading,
        isFetching,
        isError
    } = useGetOfferListQuery(nearbyOffersPayload, {
        skip: list.requestState !== RequestState.Success
    });

    const nearbyOffers = nearbyOffersResponse ? nearbyOffersResponse.results : [];

    // Neighborhood offers hits
    useEffect(() => {
        if (!isEmpty(nearbyOffers)) {
            neighborhoodOffersViewHit(
                viewType,
                nearbyOffers.map((off: {id: number}) => off.id)
            );
        }
    }, [JSON.stringify(nearbyOffers)]);

    const listingHeadline = `Oferty ${singleRegion?.name_declension_where}, które mogą Cię zainteresować`;
    const listId = "oferty_ktore_moga_cie_zainteresowac";

    return (
        <>
            <Text variant="headline_4" as="h2" className={headingStyle}>
                {listingHeadline}
            </Text>

            {!isSuccess ? (
                <NearbyOffersPanelPlaceholder />
            ) : (
                <NearbyOffersPanel
                    addressContext={
                        singleRegion
                            ? {
                                  searchedRegion: singleRegion,
                                  searchDistance: nearbyOffersPayload.distance
                              }
                            : undefined
                    }
                    offersNearby={nearbyOffers}
                    trackingMeta={{
                        listId,
                        listName: listingHeadline,
                        source: "additional",
                        tileEvents: {
                            imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                            buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                            linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                            logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                        }
                    }}
                    modalQuery={{
                        isInitialized: !isUninitialized,
                        isSuccess,
                        isLoading: isLoading || isFetching,
                        isError,
                        requestState: getRequestStateFromRtkQuery({isSuccess, isLoading, isFetching, isError}),
                        data: nearbyOffers,
                        count: nearbyOffers.length,
                        page: nearbyOffersResponse.page,
                        pageSize: nearbyOffersResponse.page_size
                    }}
                    isSidebarReserved={props.isSidebarReserved}
                />
            )}
        </>
    );
};

const headingStyle = css({
    marginBottom: 3,
    md: {
        marginBottom: 4
    }
});
